var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal fade modal-fullwidth" }, [
    _c("div", { staticClass: "modal-dialog" }, [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                title: "close",
              },
            },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _c("h3", [
            _vm._v(_vm._s(_vm.annotationDisplayName || _vm.annotationId)),
          ]),
        ]),
        _vm._v(" "),
        _vm.isValidTagset
          ? _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "list-group-container" }, [
                _c(
                  "div",
                  { staticClass: "list-group main" },
                  _vm._l(_vm.tagset.values, function (value) {
                    return _c(
                      "button",
                      {
                        key: value.id,
                        class: {
                          "list-group-item": true,
                          active: _vm.annotationValue === value,
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.annotationValue =
                              _vm.annotationValue === value ? null : value
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" + _vm._s(value.displayName) + " "
                        ),
                        _c("Debug", [_vm._v("(" + _vm._s(value.value) + ")")]),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.annotationValue
                  ? _c(
                      "div",
                      { staticClass: "category-container" },
                      [
                        _vm._l(
                          _vm.annotationValue.subAnnotationIds,
                          function (subId) {
                            return _c(
                              "ul",
                              { staticClass: "list-group category" },
                              [
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "list-group-item active category-name",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.annotationDisplayNames[subId]
                                      ) + " "
                                    ),
                                    _c("Debug", [
                                      _vm._v("(" + _vm._s(subId) + ")"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.tagset.subAnnotations[subId].values,
                                  function (subValue) {
                                    return !subValue.pos ||
                                      subValue.pos.includes(
                                        _vm.annotationValue.value
                                      )
                                      ? _c(
                                          "li",
                                          {
                                            key: subValue.value,
                                            staticClass:
                                              "list-group-item category-value",
                                          },
                                          [
                                            _c(
                                              "label",
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.selected[
                                                          _vm.annotationValue
                                                            .value +
                                                            "/" +
                                                            subId +
                                                            "/" +
                                                            subValue.value
                                                        ],
                                                      expression:
                                                        "selected[`${annotationValue.value}/${subId}/${subValue.value}`]",
                                                    },
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.selected[
                                                        _vm.annotationValue
                                                          .value +
                                                          "/" +
                                                          subId +
                                                          "/" +
                                                          subValue.value
                                                      ]
                                                    )
                                                      ? _vm._i(
                                                          _vm.selected[
                                                            _vm.annotationValue
                                                              .value +
                                                              "/" +
                                                              subId +
                                                              "/" +
                                                              subValue.value
                                                          ],
                                                          null
                                                        ) > -1
                                                      : _vm.selected[
                                                          _vm.annotationValue
                                                            .value +
                                                            "/" +
                                                            subId +
                                                            "/" +
                                                            subValue.value
                                                        ],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.selected[
                                                            _vm.annotationValue
                                                              .value +
                                                              "/" +
                                                              subId +
                                                              "/" +
                                                              subValue.value
                                                          ],
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.selected,
                                                              _vm
                                                                .annotationValue
                                                                .value +
                                                                "/" +
                                                                subId +
                                                                "/" +
                                                                subValue.value,
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.selected,
                                                              _vm
                                                                .annotationValue
                                                                .value +
                                                                "/" +
                                                                subId +
                                                                "/" +
                                                                subValue.value,
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.selected,
                                                          _vm.annotationValue
                                                            .value +
                                                            "/" +
                                                            subId +
                                                            "/" +
                                                            subValue.value,
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      subValue.displayName
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                                _c("Debug", [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(subValue.value) +
                                                      ")"
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }
                                ),
                              ],
                              2
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.annotationValue.subAnnotationIds.length === 0
                          ? _c("em", [_vm._v("No options")])
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.query))]),
            ])
          : _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "alert alert-danger" }, [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(_vm.errorMessage) + "\n\t\t\t\t"
                ),
              ]),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button", "data-dismiss": "modal" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [_vm._v("Ok")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-default",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.reset.apply(null, arguments)
                },
              },
            },
            [_vm._v("Reset")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }